import axios from 'axios';
import AppSettings from '../../../../core/AppSettings';

export const getHomeCategoriesData = ()=>{
    const url = "/wcs/resources/store/" + AppSettings.storeId + "/espot/Homepage_Tiles";
    return axios.get(url).then(response=>response.data);
};